import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { pushToast, removeToast } from '../store/slices/eoUiSlice';

export function useEoToast() {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((s) => s.eoUi.toasts);

  const toast = useCallback(
    (
      msg: string,
      kind?: '' | 'danger' | 'success',
      params?: Record<string, string>,
    ) => {
      dispatch(pushToast({ msg, kind, params }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!toasts.length) return;
    const timers = toasts.map((t) =>
      window.setTimeout(() => dispatch(removeToast(t.id)), 2400),
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, dispatch]);

  return { toast, toasts };
}
